import React from 'react';
import { SelectPicker } from 'rsuite';
import { translate } from 'react-i18next';
import './LabeledSelect.scss';


/**
 * @param {{
 *  id: number;
 *  label: string;
 *  options: {value: any, label: string};
 *  value: any;
 *  handleChange: Function;
 *  widthSize: "sm|md|lg";
 *  sorted: boolean;
 *  error: boolean;
 *  placeholder: string;
 *  searchable: boolean;
 * }} param0
 * @returns
 */
const LabeledSelect = ({
    id, label, options, value, handleChange, widthSize = "md", className, sorted, error, placeholder = "Select", searchable = true, t, ...props
}) => {
    const pickerClassName = `select-picker ${widthSize} ${error ? 'error' : ''}`

    if (sorted) {
        options = options.sort((a, b) => a.label < b.label ? -1 : a.label > b.label ? 1 : 0);
    }

    const locale = {
        searchPlaceholder: t('common:common.search')
    };

    return (
        <div className={`labeledSelect ${className}`}>
            <div className='select-label'>{label}</div>
            <SelectPicker
                className={pickerClassName}
                size="lg"
                data={options}
                onChange={handleChange}
                value={value}
                searchable={searchable}
                placeholder={placeholder}
                locale={locale}
                {...props}
            />
        </div>
    )
}

export default translate('common')(LabeledSelect);